// Add arrow to all buttons that don't have it yet.
// Runs during browser idle time to avoid blocking TTI.
var _addButtonArrows = function() {
  var buttons = document.querySelectorAll('.button:not(.button-unstyled):not(.close-button)');

  buttons.forEach(function(button) {
    if (button.querySelector('.arrow-wrapper')) return;

    // Goettling CTAs already render their own arrow — injecting .arrow-wrapper
    // breaks padding / grid alignment on mobile product pages.
    if (button.classList.contains('goettling-cta') ||
        button.classList.contains('quantity-minus') ||
        button.classList.contains('quantity-plus') ||
        button.classList.contains('cart-items__remove') ||
        button.classList.contains('deferred-media__poster-button')) return;

    var arrowWrapper = document.createElement('div');
    arrowWrapper.className = 'arrow-wrapper';
    var arrow = document.createElement('div');
    arrow.className = 'arrow';
    arrowWrapper.appendChild(arrow);
    button.appendChild(arrowWrapper);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    (typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout)(_addButtonArrows);
  });
} else {
  (typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout)(_addButtonArrows);
}
